module.exports = __webpack_public_path__ + "static/media/25KM.7667a7ea.webp";